import { render, staticRenderFns } from "./TopicHeaderPreview.vue?vue&type=template&id=03fef46e&scoped=true&"
import script from "./TopicHeaderPreview.vue?vue&type=script&lang=js&"
export * from "./TopicHeaderPreview.vue?vue&type=script&lang=js&"
import style0 from "./TopicHeaderPreview.vue?vue&type=style&index=0&id=03fef46e&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03fef46e",
  null
  
)

export default component.exports